import React  from 'react';
import AddWebsiteComponent from './website-create.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import WebsitePageComponents from './website-page.component';


export const WebsiteComponent = ({paginationData,setPageData,additionButtons,onEdit,columnDefs, id,selectedPages,handleInnerFormChange,selectedWebsites,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Website Information',
        component:<AddWebsiteComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedWebsites={selectedWebsites}
        />,
        isVisible:true,
    },
    {
        id:2,
        title:'Website Page Information',
        component:<WebsitePageComponents 
        rowData={selectedPages}
        columnDefs={columnDefs}
        onEdit={onEdit}
        additionButtons={additionButtons}
        paginationData={paginationData}
        setPageData={setPageData}
        />,
        isVisible: id > 0 ? true : false,
    },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[520px] overflow-auto">
       
     
       <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
     <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button><button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
            Save
          </button>
        </div>
       </div>
  )
}
export default WebsiteComponent;
